import type { ReactNode } from 'react'
import { collageVariables, type CollageStyle } from '../../lib/collage'

/**
 * The drawing of a collage (1.168.0), one for every place that shows one: the
 * bubble, the preview in the sheet and the defaults in the administration.
 * Two drawings would be two layouts that drift apart, and the preview would
 * promise what the chat does not show.
 *
 * The tiles are whatever the caller hands in (a `Standbild` in the chat, a
 * local picture in the sheet, an empty field in the administration), in the
 * order of the post's photos. The first tile is the big one where a layout
 * has one.
 */
export function Collage({ style, tiles }: { style: CollageStyle; tiles: ReactNode[] }) {
  return (
    <div
      className="collage"
      data-layout={style.layout}
      data-count={tiles.length}
      style={collageVariables(style)}
    >
      {tiles.map((tile, i) => (
        <div key={i} className="collage__tile">
          {tile}
        </div>
      ))}
    </div>
  )
}
